const MAX_STICKY_NOTES = 6;

export type StickyNote = {
  title: string;
  body: string;
};

export function normalizeStickyNotes(notes: StickyNote[]): StickyNote[] {
  return notes
    .map((n) => ({ title: (n.title || "").trim(), body: (n.body || "").trim() }))
    .filter((n) => n.title || n.body)
    .slice(0, MAX_STICKY_NOTES);
}

export function parseStickyNotes(settings: Record<string, unknown>): StickyNote[] {
  const rawTitle = typeof settings.sales_console_sticky_note_title === "string" ? settings.sales_console_sticky_note_title : "";
  const rawBody = typeof settings.sales_console_sticky_note_body === "string" ? settings.sales_console_sticky_note_body : "";
  const bodyTrimmed = rawBody.trim();
  if (bodyTrimmed.startsWith("[")) {
    try {
      const parsed = JSON.parse(bodyTrimmed) as Array<Record<string, unknown>>;
      if (Array.isArray(parsed)) {
        return normalizeStickyNotes(parsed.map((row) => ({ title: typeof row?.title === "string" ? row.title : "", body: typeof row?.body === "string" ? row.body : "" })));
      }
    } catch {
      /* fall back to legacy mode */
    }
  }
  return normalizeStickyNotes([{ title: rawTitle, body: rawBody }]);
}

export function payoffStateStorageKey(orgId: string | null): string {
  return `bb-rto-payoff-state-${orgId || "global"}`;
}

export function resolveSalesConsoleRtoDisplayTitle(envelope: Record<string, unknown>): string {
  const settings = (envelope.settings ?? {}) as Record<string, unknown>;
  const storedRaw = typeof settings.sales_console_rto_title === "string" ? settings.sales_console_rto_title.trim() : "";
  const useMfg = settings.rto_use_manufacturer_terms === true;
  const mfgIdRaw = settings.rto_source_manufacturer_org_id;
  const mfgId = typeof mfgIdRaw === "string" && mfgIdRaw.trim() ? mfgIdRaw.trim() : "";
  const opts = Array.isArray(envelope.manufacturer_options) ? (envelope.manufacturer_options as Array<{ id?: string; name?: string }>) : [];
  const suffix = "RTO Terms Calculator";
  const effectiveInheritedProvider = typeof envelope.effective_sales_console_rto_title === "string" ? envelope.effective_sales_console_rto_title.trim() : "";
  if (useMfg) {
    const inheritedProvider = effectiveInheritedProvider || "";
    if (inheritedProvider) return /rto terms calculator|rto term calculator/i.test(inheritedProvider) ? inheritedProvider : `${inheritedProvider} ${suffix}`;
  }
  if (storedRaw) return /rto terms calculator|rto term calculator/i.test(storedRaw) ? storedRaw : `${storedRaw} ${suffix}`;
  if (useMfg && opts.length) {
    const pick = mfgId ? opts.find((o) => String(o?.id || "") === mfgId) ?? opts[0] : opts[0];
    const name = String(pick?.name || "Manufacturer").trim() || "Manufacturer";
    return `${name} ${suffix}`;
  }
  return "RTO term calculator (v1.0)";
}

export { MAX_STICKY_NOTES };

